var sdjproject = {
    typeList: {
        "1": "product",
        "2": "technology",
        "3": "project",
        "4": "design",
        "6": "company",
        "7": "exportcompany",
        "8": "IntelligentProduct",
        "9": "intelligentengineeringdesign",
        "10": "intelligentsystemintegration",
    },
    getType: function(type) {
        return this.typeList[type];
    },
    listType: {
        "1": "apply",
        "2": "excellent",
        "3": "best"
    },
    getListType: function(type) {
        if (type) {
            return this.listType[type];
        }
        return this.listType[1];
    },
}
export default sdjproject